var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbItems}}),_c('v-card',[_c('Header',{attrs:{"title":"Recently Created Events"}}),(_vm.events)?_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.events,"items-per-page":25},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{name: 'eventmanagerView', params: {id: item.id}}}},[_vm._v(_vm._s(item.name))])]}},{key:"item.created_on",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("moment")(item.created_on,'L LT'))+" ")]}},{key:"item.from",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("moment")(item.from,'L'))+" ")]}},{key:"item.till",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("moment")(item.till,'L'))+" ")]}}],null,false,2948606746)}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }